import React, { useEffect, useMemo, useState } from "react";
import { Link, useOutletContext } from "react-router-dom";
import { useDispatch } from "react-redux";
import Button from "../Recommendations/components/Button/Button";
import { generateIdeas } from "../../../../redux/actions";
import { buildGenerateIdeasPrompt } from "./buildGenerateIdeasPrompt";
import "./NextStepsSection.scss";

function NextStepsSection({
  interestedCareers,
  isRegenerating,
  companionId,
  isLoading,
}) {
  const { user } = useOutletContext();
  const dispatch = useDispatch();
  const loadingWords = useMemo(
    () => ["Thinking", "Exploring", "Crafting", "Personalizing"],
    [],
  );
  const [loadingStep, setLoadingStep] = useState(0);

  useEffect(() => {
    if (!isLoading) {
      setLoadingStep(0);
      return undefined;
    }

    const timer = setInterval(() => {
      setLoadingStep(
        (currentStep) => (currentStep + 1) % (loadingWords.length * 4),
      );
    }, 800);

    return () => clearInterval(timer);
  }, [isLoading, loadingWords.length]);

  const loadingWord =
    loadingWords[Math.floor(loadingStep / 4)] || loadingWords[0];
  const loadingDots = loadingStep % 4 === 0 ? "" : ".".repeat(loadingStep % 4);

  const handleGenerateIdeas = () => {
    const prompt = buildGenerateIdeasPrompt(user, interestedCareers);
    dispatch(generateIdeas({ prompt, companionId }));
  };

  return (
    <div className="actionPlan__section actionPlan__section--nextSteps">
      <h3>Next Steps</h3>
      {!companionId ? (
        <p className="actionPlan__section-description">
          Add, move, or update your next steps anytime. Drag ideas from the left
          or create your own.
        </p>
      ) : (
        <p className="actionPlan__section-description">
          {isRegenerating
            ? "Add, move, or update your steps anytime. You can also"
            : "Not sure where to start? Click Generate ideas or"}{" "}
          explore with{" "}
          <Link to={`/profile/ai-companions/${companionId}/career_buddy`}>
            Career Buddy
          </Link>
          .
        </p>
      )}
      {companionId &&
        (isLoading ? (
          <button
            type="button"
            className={`button button__selected ${isRegenerating ? "actionPlan__btn--generate" : ""} actionPlan__btn__generate actionPlan__btn__generate--loading `}
            disabled
            aria-live="polite"
            aria-label={`${loadingWord}${loadingDots}`}
          >
            <p className="actionPlan__btn__generate-text button__text button__text__selected">
              {loadingWord}
              <span className="actionPlan__btn__generate-dots button__text button__text__selected">
                {loadingDots}
              </span>
            </p>
          </button>
        ) : (
          <Button
            active={false}
            className={`${isRegenerating ? "actionPlan__btn--generate" : ""} actionPlan__btn__generate`}
            text={isRegenerating ? "Regenerate Ideas" : "Generate Ideas"}
            isLoader={false}
            handeClick={handleGenerateIdeas}
          />
        ))}
    </div>
  );
}

export default React.memo(NextStepsSection);
